import alertManagement from "./alertManagement/de";
import assetManagement from "./assetManagement/de";
import configurator from "./configurator/de";
import development from "./development/de";
import deviceManagement from "./deviceManagement/de";
import securityCenter from "./securityCenter/de";
import softwareManagement from "./softwareManagement/de";
import feedback from "./feedback/de";
import groups from "./groups/de";
import fleetInventory from "./fleetInventory/de";
import settings from "./settings/de";
import noAccessMessage from "./noAccessMessage/de";
import home from "./home/de";
import userManagement from "./userManagement/de";

export default {
  development,
  configurator,
  alertManagement,
  feedback,
  groups,
  fleetInventory,
  settings,
  assetManagement,
  deviceManagement,
  securityCenter,
  noAccessMessage,
  softwareManagement,
  home,
  userManagement,
};
